import * as THREE from "three";

export const loadTexture = (url, onProcess) =>
  new Promise((resolve, reject) => {
    new THREE.TextureLoader().load(url, resolve, onProcess, reject);
  });
